export const NEW_YEAR_2026_OPEN_TIME =
  process.env.NEXT_PUBLIC_NEW_YEAR_2026_OPEN_TIME || '2026-01-01 00:00:00';
